import {Component, Input, OnInit, OnChanges} from '@angular/core';
import {Params, RouterLink} from '@angular/router';
import {Observable} from 'rxjs';
import { PageInfo } from '../../interfaces/pageInfo';
import { AsyncPipe, CommonModule } from '@angular/common';

interface Entry {
  title: Observable<string>;
  link: any[];
  queryParams?: Params;
  last: boolean;
}

@Component({
    selector: 'gbc-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    imports: [AsyncPipe, RouterLink, CommonModule],
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnChanges, OnInit {
  @Input()
  public pageInfo: PageInfo;

  public entries: Entry[] = [];

  ngOnChanges() {
    this.updateEntries();
  }

  ngOnInit() {
    this.updateEntries();
  }

  updateEntries() {
    if (this.pageInfo) {
      this.entries = this.pageToEntries(this.pageInfo);
    }
  }

  entriesTrackByFn(index: number, item: Entry) {
    return item.link;
  }

  pageToEntries(page: PageInfo): Entry[] {
    const entries: Entry[] = [];
    let p: PageInfo | null = page;
    while (p) {
      entries.unshift({
        title: p.breadcrumb ? p.breadcrumb : p.title,
        last: false,
        link: p.link,
        queryParams: p.queryParams
      });
      p = p.parent;
    }
    entries[entries.length - 1].last = true;
    return entries;
  }
}
